<template>
  <div class="d-flex flex-column flex-lg-row min-vh-100 bg-light">
    <Sidebar
      :class="{ 'd-none d-lg-flex': !sidebarOpen }"
      @close-sidebar="sidebarOpen = false"
    />

    <div class="main-content">
      <Header @toggle-sidebar="sidebarOpen = !sidebarOpen" />

      <main class="container-fluid p-4">
        <!-- ERROR -->
        <div
          v-if="error"
          class="alert alert-danger alert-dismissible fade show"
        >
          {{ error }}

          <button
            type="button"
            class="btn-close"
            @click="error = null"
          ></button>
        </div>

        <!-- CONTENIDO -->
        <!--
          El módulo se dibuja de inmediato: encabezado, filtros y encabezado de
          la tabla. El estado de carga vive solo dentro del tbody, así al
          entrar o al cambiar de página no se vuelve a montar toda la pantalla.
        -->
        <div
          v-if="!permisos || permisos?.listar"
          class="clientes-container"
        >
          <div class="clientes-header">
            <div>
              <h2>Gestión de Clientes</h2>

              <p>
                Listado general de clientes registrados
              </p>
            </div>

            <!-- PERMISO CREAR -->
            <button
              v-if="permisos?.crear"
              type="button"
              class="btn-nuevo"
              @click="openAddModal"
            >
              Nuevo Cliente
            </button>
          </div>

          <!-- FILTROS (se consultan contra la base de datos) -->
          <div class="clientes-filtros">
            <div class="filtro-campo">
              <label>RFC</label>

              <input
                v-model.trim="filtroRfc"
                type="text"
                placeholder="Ej. PRBA010101"
                @keyup.enter="aplicarFiltros"
              />
            </div>

            <div class="filtro-campo">
              <label>Nombre o razón social</label>

              <input
                v-model.trim="filtroNombre"
                type="text"
                placeholder="Ej. Comercial Sonora"
                @keyup.enter="aplicarFiltros"
              />
            </div>

            <div class="filtro-campo">
              <label>Creado desde</label>

              <input
                v-model="filtroDesde"
                type="date"
              />
            </div>

            <div class="filtro-campo">
              <label>Creado hasta</label>

              <input
                v-model="filtroHasta"
                type="date"
              />
            </div>

            <div class="filtro-acciones">
              <button
                type="button"
                class="btn-filtro btn-filtro-primario"
                :disabled="loading"
                @click="aplicarFiltros"
              >
                Buscar
              </button>

              <button
                type="button"
                class="btn-filtro"
                :disabled="loading"
                @click="limpiarFiltros"
              >
                Limpiar
              </button>
            </div>
          </div>

          <div class="clientes-content">
            <div class="table-responsive">
              <table
                class="clientes-table"
              >
                <thead>
                  <tr>
                    <th>#</th>
                    <th>RFC</th>
                    <th>Razón Social</th>
                    <th>Nombre</th>
                    <th>Email</th>
                    <th>Teléfono</th>
                    <th>Fecha de creación</th>

                    <!-- COLUMNA ACCIONES -->
                    <th
                      v-if="
                        permisos?.actualizar ||
                        permisos?.eliminar
                      "
                    >
                      Acciones
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <!-- CARGANDO: solo el cuerpo de la tabla -->
                  <tr v-if="loading">
                    <td
                      :colspan="totalColumnas"
                      class="text-center text-muted py-5"
                    >
                      <span
                        class="spinner-border spinner-border-sm me-2"
                      ></span>

                      Cargando clientes...
                    </td>
                  </tr>

                  <template v-else>
                    <tr
                      v-for="(cliente, index) in clientes"
                      :key="cliente.id"
                    >
                      <td>
                        {{ numeroFila(index) }}
                      </td>

                      <td>
                        {{ cliente.rfc }}
                      </td>

                      <td>
                        {{ cliente.razon_social }}
                      </td>

                      <td>
                        {{ cliente.nombre }}
                        {{ cliente.apellidos }}
                      </td>

                      <td>
                        {{ cliente.email }}
                      </td>

                      <td>
                        {{ cliente.telefono }}
                      </td>

                      <td>
                        {{ fechaCreacion(cliente) }}
                      </td>

                      <!-- ACCIONES -->
                      <td
                        v-if="
                          permisos?.actualizar ||
                          permisos?.eliminar
                        "
                      >
                        <!-- PERMISO ACTUALIZAR -->
                        <button
                          v-if="permisos?.actualizar"
                          type="button"
                          class="btn btn-sm btn-warning me-2"
                          @click="openEditModal(cliente)"
                        >
                          <i class="bi bi-pencil"></i>
                        </button>

                        <!-- PERMISO ELIMINAR -->
                        <button
                          v-if="permisos?.eliminar"
                          type="button"
                          class="btn btn-sm btn-danger"
                          @click="deleteCliente(cliente.id)"
                        >
                          <i class="bi bi-trash"></i>
                        </button>
                      </td>
                    </tr>

                    <tr v-if="clientes.length === 0">
                      <td
                        :colspan="totalColumnas"
                        class="text-center text-muted py-5"
                      >
                        {{
                          hayFiltros
                            ? 'Con esos filtros no hay resultados.'
                            : 'No hay clientes registrados'
                        }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <!--
              PAGINACIÓN: cada botón dispara una consulta nueva al API.
              El navegador solo conserva la página actual.
            -->
            <div class="tabla-paginacion">
              <small>
                Mostrando {{ clientes.length }} de
                {{ meta.total }} &middot;
                Página {{ meta.current_page }} de
                {{ meta.last_page }}
              </small>

              <div class="paginacion-botones">
                <button
                  type="button"
                  class="btn-filtro"
                  :disabled="loading || meta.current_page <= 1"
                  @click="irPagina(meta.current_page - 1)"
                >
                  &lsaquo; Anterior
                </button>

                <button
                  type="button"
                  class="btn-filtro"
                  :disabled="
                    loading ||
                    meta.current_page >= meta.last_page
                  "
                  @click="irPagina(meta.current_page + 1)"
                >
                  Siguiente &rsaquo;
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- SIN PERMISO PARA LISTAR -->
        <div
          v-if="permisos && !permisos?.listar"
          class="alert alert-warning text-center"
        >
          No tienes permiso para ver los clientes.
        </div>
      </main>
    </div>

    <!-- OVERLAY MÓVIL -->
    <div
      v-if="sidebarOpen"
      class="sidebar-overlay d-lg-none"
      @click="sidebarOpen = false"
    ></div>

    <!-- MODAL CREAR/EDITAR -->
    <BaseModal
      v-model:visible="modalVisible"
      :title="modalTitle"
    >
      <div class="container-fluid">
        <!-- PASO 1: INFORMACIÓN GENERAL -->
        <div v-if="step === 1">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">
                RFC
              </label>

              <input
                v-model="clienteForm.rfc"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Razón Social
              </label>

              <input
                v-model="clienteForm.razon_social"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">
                Nombre
              </label>

              <input
                v-model="clienteForm.nombre"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Apellidos
              </label>

              <input
                v-model="clienteForm.apellidos"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">
                Email 1
              </label>

              <input
                v-model="clienteForm.email"
                type="email"
                class="form-control"
              />
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">
                Email 2
              </label>

              <input
                v-model="clienteForm.email2"
                type="email"
                class="form-control"
              />
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">
                Email 3
              </label>

              <input
                v-model="clienteForm.email3"
                type="email"
                class="form-control"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">
                Teléfono
              </label>

              <input
                v-model="clienteForm.telefono"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Régimen Fiscal
              </label>

              <select
                v-model="clienteForm.regimen_fiscal_id"
                class="form-control"
              >
                <option
                  disabled
                  value=""
                >
                  Seleccione régimen
                </option>

                <option
                  v-for="item in regimenesFiscales"
                  :key="item.id"
                  :value="item.id"
                >
                  {{ item.codigo }} -
                  {{ item.descripcion }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-md-6 mb-3">
            <label class="form-label">
              Uso de CFDI
            </label>

            <select
              v-model="clienteForm.uso_cfdi_id"
              class="form-control"
            >
              <option
                disabled
                value=""
              >
                Seleccione uso de CFDI
              </option>

              <option
                v-for="item in usosCfdi"
                :key="item.id"
                :value="item.id"
              >
                {{ item.usocfdi }} -
                {{ item.descripcion }}
              </option>
            </select>
          </div>
        </div>

        <!-- PASO 2: DATOS FISCALES -->
        <div v-if="step === 2">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">
                Calle
              </label>

              <input
                v-model="clienteForm.calle"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label">
                Exterior
              </label>

              <input
                v-model="clienteForm.numero_exterior"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-3 mb-3">
              <label class="form-label">
                Interior
              </label>

              <input
                v-model="clienteForm.numero_interior"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-4 mb-3">
              <label class="form-label">
                Colonia
              </label>

              <input
                v-model="clienteForm.colonia"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">
                Ciudad
              </label>

              <input
                v-model="clienteForm.ciudad"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-4 mb-3">
              <label class="form-label">
                Estado
              </label>

              <input
                v-model="clienteForm.estado"
                type="text"
                class="form-control"
              />
            </div>
          </div>

          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">
                Delegación / Municipio
              </label>

              <input
                v-model="clienteForm.delegacion"
                type="text"
                class="form-control"
              />
            </div>

            <div class="col-md-6 mb-3">
              <label class="form-label">
                Código Postal
              </label>

              <input
                v-model="clienteForm.codigo_postal"
                type="text"
                class="form-control"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- FOOTER -->
      <template #footer>
        <div class="d-flex justify-content-between w-100">
          <button
            v-if="step > 1"
            type="button"
            class="btn btn-secondary"
            @click="prevStep"
          >
            Atrás
          </button>

          <div class="ms-auto">
            <button
              v-if="step < 2"
              type="button"
              class="btn btn-primary"
              @click="nextStep"
            >
              Siguiente
            </button>

            <button
              v-else-if="
                editingId
                  ? permisos?.actualizar
                  : permisos?.crear
              "
              type="button"
              class="btn btn-success"
              :disabled="loading"
              @click="saveCliente"
            >
              <span
                v-if="loading"
                class="spinner-border spinner-border-sm me-2"
              ></span>

              Guardar
            </button>
          </div>
        </div>
      </template>
    </BaseModal>

    <!-- MODAL CONFIRMACIÓN -->
    <ConfirmModal
      v-model:visible="confirmModalVisible"
      :message="confirmMessage"
      @confirmed="onConfirmDelete"
    />
  </div>
</template>

<script>
import {
  ref,
  reactive,
  computed,
  onMounted,
  onBeforeUnmount
} from 'vue';

import api, {
  obtenerPermisosPorModulo
} from '@/services/api.js';

import Header from '@/components/HeaderVue.vue';
import Sidebar from '@/components/Sidebar.vue';
import BaseModal from '@/components/BaseModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import { useFormatters } from '@/composables/useFormatters.js';


export default {
  name: 'ClientesView',

  components: {
    Header,
    Sidebar,
    BaseModal,
    ConfirmModal
  },

  setup() {
    const sidebarOpen = ref(false);
    const clientes = ref([]);
    const loading = ref(false);
    const error = ref(null);

    const regimenesFiscales = ref([]);
    const usosCfdi = ref([]);

    const modalVisible = ref(false);
    const modalTitle = ref('');
    const step = ref(1);
    const editingId = ref(null);

    const clienteForm = reactive({
      rfc: '',
      razon_social: '',
      nombre: '',
      apellidos: '',
      email: '',
      email2: '',
      email3: '',
      telefono: '',
      calle: '',
      numero_exterior: '',
      numero_interior: '',
      colonia: '',
      ciudad: '',
      estado: '',
      delegacion: '',
      codigo_postal: '',
      regimen_fiscal_id: '',
      uso_cfdi_id: ''
    });

    const confirmModalVisible = ref(false);
    const confirmMessage = ref('');
    const deletingId = ref(null);

    /*
     * null significa que los permisos aún no cargan.
     */
    const permisos = ref(null);

    const {
      formatDate
    } = useFormatters();
    /*
    |--------------------------------------------------------------------------
    | Filtros y paginación (se resuelven en el servidor)
    |--------------------------------------------------------------------------
    */
    const filtroRfc = ref('');
    const filtroNombre = ref('');
    const filtroDesde = ref('');
    const filtroHasta = ref('');

    const pagina = ref(1);

    // El módulo trabaja de 5 en 5.
    const porPagina = 5;

    const meta = ref({
      total: 0,
      current_page: 1,
      per_page: porPagina,
      last_page: 1
    });

    /*
     * Identifica la petición en curso: si el usuario cambia de página o de
     * filtro antes de que responda la anterior, la respuesta vieja se descarta.
     */
    let peticionActual = 0;

    /*
     * Se separa de 'loading' para que guardar o eliminar no vacíe la tabla.
     */
    const guardando = ref(false);

    const hayFiltros = computed(() => {
      return !!(
        filtroRfc.value ||
        filtroNombre.value ||
        filtroDesde.value ||
        filtroHasta.value
      );
    });

    const totalColumnas = computed(() => {
      return permisos.value?.actualizar ||
        permisos.value?.eliminar
        ? 8
        : 7;
    });

    const numeroFila = (index) => {
      const pag = meta.value.current_page || 1;

      return (pag - 1) * porPagina + index + 1;
    };

    const fechaCreacion = (registro) => {
      const valor =
        registro?.created_at ||
        registro?.updated_at;

      if (!valor) {
        return '-';
      }

      return formatDate(valor);
    };


    const permisoActivo = (valor) => {
      return (
        valor === true ||
        valor === 1 ||
        valor === '1' ||
        valor === 'true'
      );
    };

    /*
    |--------------------------------------------------------------------------
    | Cargar permisos
    |--------------------------------------------------------------------------
    */
    const fetchPermisos = async () => {
      try {
        const respuesta =
          await obtenerPermisosPorModulo(
            'clientes'
          );

        permisos.value = {
          listar: permisoActivo(
            respuesta?.listar
          ),

          crear: permisoActivo(
            respuesta?.crear
          ),

          actualizar: permisoActivo(
            respuesta?.actualizar
          ),

          eliminar: permisoActivo(
            respuesta?.eliminar
          )
        };
      } catch (e) {
        permisos.value = {
          listar: false,
          crear: false,
          actualizar: false,
          eliminar: false
        };

        error.value =
          'No fue posible cargar los permisos de clientes.';
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Cargar clientes
    |--------------------------------------------------------------------------
    */
        const fetchClientes = async () => {
      if (!permisos.value?.listar) {
        clientes.value = [];
        return;
      }

      const idPeticion = ++peticionActual;

      loading.value = true;
      error.value = null;

      try {
        const res = await api.get('/clientes', {
          params: {
            rfc: filtroRfc.value || undefined,
            nombre: filtroNombre.value || undefined,
            desde: filtroDesde.value || undefined,
            hasta: filtroHasta.value || undefined,
            page: pagina.value,
            per_page: porPagina
          }
        });

        // Llegó tarde: ya se pidió otra página u otro filtro.
        if (idPeticion !== peticionActual) {
          return;
        }

        clientes.value = res.data?.data || [];

        const metaRespuesta = res.data?.meta;

        if (metaRespuesta) {
          meta.value = metaRespuesta;
          pagina.value = metaRespuesta.current_page;
        } else {
          meta.value = {
            total: res.data?.total || 0,
            current_page: pagina.value,
            per_page: porPagina,
            last_page: 1
          };
        }
      } catch (e) {
        if (idPeticion !== peticionActual) {
          return;
        }

        clientes.value = [];

        error.value =
          'Error al cargar los clientes: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      } finally {
        if (idPeticion === peticionActual) {
          loading.value = false;
        }
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Acciones de filtro y paginación
    |--------------------------------------------------------------------------
    | Todas vuelven a consultar la base de datos; nada se filtra en memoria.
    */
    const aplicarFiltros = () => {
      pagina.value = 1;
      fetchClientes();
    };

    const limpiarFiltros = () => {
      filtroRfc.value = '';
      filtroNombre.value = '';
      filtroDesde.value = '';
      filtroHasta.value = '';
      pagina.value = 1;

      fetchClientes();
    };

    const irPagina = (n) => {
      if (
        n < 1 ||
        n > (meta.value.last_page || 1) ||
        n === meta.value.current_page
      ) {
        return;
      }

      pagina.value = n;
      fetchClientes();
    };

    /*
    |--------------------------------------------------------------------------
    | Cargar catálogos SAT
    |--------------------------------------------------------------------------
    */
    const fetchSatCatalogs = async () => {
      try {
        const res = await api.get('/sat');

        regimenesFiscales.value =
          res.data?.regimenes_fiscales || [];

        usosCfdi.value =
          res.data?.usos_cfdi || [];
      } catch (e) {
        error.value =
          'Error al cargar catálogos SAT: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Abrir nuevo cliente
    |--------------------------------------------------------------------------
    */
    const openAddModal = async () => {
      if (!permisos.value?.crear) {
        error.value =
          'No tienes permiso para crear clientes.';

        return;
      }

      modalTitle.value = 'Nuevo Cliente';

      Object.keys(clienteForm).forEach(
        (key) => {
          clienteForm[key] = '';
        }
      );

      editingId.value = null;
      step.value = 1;

      await fetchSatCatalogs();

      modalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Abrir editar cliente
    |--------------------------------------------------------------------------
    */
    const openEditModal = async (cliente) => {
      if (!permisos.value?.actualizar) {
        error.value =
          'No tienes permiso para actualizar clientes.';

        return;
      }

      Object.assign(
        clienteForm,
        cliente
      );

      editingId.value = cliente.id;
      modalTitle.value = 'Editar Cliente';
      step.value = 1;

      await fetchSatCatalogs();

      modalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Guardar cliente
    |--------------------------------------------------------------------------
    */
    const saveCliente = async () => {
      if (
        editingId.value &&
        !permisos.value?.actualizar
      ) {
        error.value =
          'No tienes permiso para actualizar clientes.';

        return;
      }

      if (
        !editingId.value &&
        !permisos.value?.crear
      ) {
        error.value =
          'No tienes permiso para crear clientes.';

        return;
      }

      guardando.value = true;
      error.value = null;

      try {
        if (editingId.value) {
          await api.put(
            `/clientes/${editingId.value}`,
            clienteForm
          );
        } else {
          await api.post(
            '/clientes',
            clienteForm
          );
        }

        await fetchClientes();

        modalVisible.value = false;
      } catch (e) {
        error.value =
          'Error al guardar el cliente: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      } finally {
        guardando.value = false;
      }
    };

    const nextStep = () => {
      if (step.value < 2) {
        step.value++;
      }
    };

    const prevStep = () => {
      if (step.value > 1) {
        step.value--;
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Solicitar eliminación
    |--------------------------------------------------------------------------
    */
    const deleteCliente = (id) => {
      if (!permisos.value?.eliminar) {
        error.value =
          'No tienes permiso para eliminar clientes.';

        return;
      }

      deletingId.value = id;

      confirmMessage.value =
        '¿Seguro que deseas eliminar este cliente?';

      confirmModalVisible.value = true;
    };

    /*
    |--------------------------------------------------------------------------
    | Confirmar eliminación
    |--------------------------------------------------------------------------
    */
    const onConfirmDelete = async () => {
      if (!permisos.value?.eliminar) {
        error.value =
          'No tienes permiso para eliminar clientes.';

        confirmModalVisible.value = false;
        return;
      }

      if (!deletingId.value) {
        return;
      }

      guardando.value = true;
      error.value = null;

      try {
        await api.delete(
          `/clientes/${deletingId.value}`
        );

        await fetchClientes();
      } catch (e) {
        error.value =
          'Error al eliminar el cliente: ' +
          (
            e.response?.data?.message ||
            e.message
          );
      } finally {
        guardando.value = false;
        deletingId.value = null;
        confirmModalVisible.value = false;
      }
    };

    /*
    |--------------------------------------------------------------------------
    | Inicialización
    |--------------------------------------------------------------------------
    */
    onMounted(async () => {
      await fetchPermisos();

      if (permisos.value?.listar) {
        await fetchClientes();
      }
    });

    /*
    |--------------------------------------------------------------------------
    | Salir del módulo: no dejar datos en memoria
    |--------------------------------------------------------------------------
    | Se descarta el listado y se invalida cualquier petición en vuelo para que
    | su respuesta no reviva el estado ya desmontado.
    */
    onBeforeUnmount(() => {
      peticionActual++;

      clientes.value = [];

      meta.value = {
        total: 0,
        current_page: 1,
        per_page: porPagina,
        last_page: 1
      };
    });

    return {
      sidebarOpen,

      clientes,
      loading,
      error,

      modalVisible,
      modalTitle,

      clienteForm,
      regimenesFiscales,
      usosCfdi,

      editingId,
      step,

      nextStep,
      prevStep,
      saveCliente,

      confirmModalVisible,
      confirmMessage,

      permisos,

      filtroRfc,
      filtroNombre,
      filtroDesde,
      filtroHasta,
      meta,
      guardando,
      hayFiltros,
      totalColumnas,

      numeroFila,
      fechaCreacion,
      aplicarFiltros,
      limpiarFiltros,
      irPagina,

      openAddModal,
      openEditModal,
      deleteCliente,
      onConfirmDelete
    };
  }
};
</script>



<style scoped>
.main-content{
    flex:1;
    margin-top:60px;
    transition:margin-left .3s ease;
}

@media (min-width:992px){
    .main-content{
        margin-left:250px;
    }
}

.sidebar-overlay{
    position:fixed;
    inset:0;
    background:rgba(0,0,0,.5);
    z-index:1019;
}

main{
    min-height:calc(100vh - 60px);
}

/* CONTENEDOR */

.clientes-container{
    width:100%;
    background:#fff;
    border-radius:24px;
    overflow:hidden;
    border:1px solid #edf0f5;
    box-shadow:0 15px 40px rgba(0,0,0,.05);
}

/* HEADER */

.clientes-header{
    display:flex;
    justify-content:space-between;
    align-items:center;
    padding:28px;
    border-bottom:1px solid #edf0f5;
}

.clientes-header h2{
    margin:0;
    font-size:24px;
    font-weight:700;
    color:#111827;
}

.clientes-header p{
    margin-top:6px;
    color:#6b7280;
}

/* BOTÓN */

.btn-nuevo{
    border:none;
    background:#2563eb;
    color:white;
    padding:12px 22px;
    border-radius:14px;
    font-weight:600;
}

/* CONTENIDO */

.clientes-content{
    padding:20px;
    overflow-x:auto;
}

/* TABLA */

.clientes-table{
    width:100%;
    border-collapse:separate;
    border-spacing:0 12px;
}

.clientes-table thead th{
    color:#64748b;
    font-size:13px;
    text-transform:uppercase;
    font-weight:700;
    padding:0 20px 10px;
    white-space:nowrap;
}

.clientes-table tbody tr{
    background:#f8fafc;
}

.clientes-table td{
    padding:18px 20px;
    white-space:nowrap;
}

.clientes-table tbody tr td:first-child{
    border-radius:16px 0 0 16px;
}

.clientes-table tbody tr td:last-child{
    border-radius:0 16px 16px 0;
}

/* BOTONES CRUD */

.btn-warning{
    border:none;
    border-radius:12px;
}

.btn-danger{
    border:none;
    border-radius:12px;
}

/* DATATABLE */


/* FILTROS */

.clientes-filtros{
  display:flex;
  flex-wrap:wrap;
  gap:16px;
  align-items:flex-end;
  padding:20px 28px 0;
}

.filtro-campo{
  display:flex;
  flex-direction:column;
  gap:6px;
}

.filtro-campo label{
  color:#64748b;
  font-size:12px;
  font-weight:700;
  text-transform:uppercase;
}

.filtro-campo input{
  border:1px solid #e2e8f0;
  border-radius:12px;
  padding:10px 14px;
  min-width:200px;
}

.filtro-campo input:focus{
  outline:none;
  border-color:#2563eb;
}

.filtro-acciones{
  display:flex;
  gap:10px;
}

.btn-filtro{
  border:1px solid #e2e8f0;
  background:white;
  color:#334155;
  padding:10px 18px;
  border-radius:12px;
  font-weight:600;
}

.btn-filtro:hover:not(:disabled){
  background:#f1f5f9;
}

.btn-filtro:disabled{
  opacity:.5;
}

.btn-filtro-primario{
  background:#2563eb;
  border-color:#2563eb;
  color:white;
}

.btn-filtro-primario:hover:not(:disabled){
  background:#1d4ed8;
}

/* PAGINACIÓN */

.tabla-paginacion{
  display:flex;
  flex-wrap:wrap;
  justify-content:space-between;
  align-items:center;
  gap:12px;
  padding-top:16px;
  border-top:1px solid #edf0f5;
  color:#64748b;
}

.paginacion-botones{
  display:flex;
  gap:10px;
}

@media (max-width:768px){
  .clientes-filtros{
    padding:20px 20px 0;
  }

  .filtro-campo,
  .filtro-campo input{
    width:100%;
    min-width:0;
  }

  .filtro-acciones{
    width:100%;
  }

  .btn-filtro{
    flex:1;
  }
}


/* RESPONSIVE */

@media(max-width:768px){

    .clientes-header{
        flex-direction:column;
        align-items:flex-start;
        gap:15px;
    }

    .btn-nuevo{
        width:100%;
    }

}
</style>
